import { render, staticRenderFns } from "./InvoicePreview.vue?vue&type=template&id=8040fb0c&scoped=true"
import script from "./InvoicePreview.vue?vue&type=script&lang=js"
export * from "./InvoicePreview.vue?vue&type=script&lang=js"
import style0 from "./InvoicePreview.vue?vue&type=style&index=0&id=8040fb0c&prod&lang=scss&scoped=true"
import style1 from "./InvoicePreview.vue?vue&type=style&index=1&id=8040fb0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8040fb0c",
  null
  
)

export default component.exports